export function StatusBadge({ status }: { status: string }) {
  return <span aria-label={`Stato: ${status}`}>{status}</span>;
}
